import React, { Component } from "react";
import "react-bootstrap";

import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../api/apiConstant";
import store from "../../store/configureStore";
import { Link } from "react-router-dom";
import { lang } from "../../config/lang";
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from "../../actions/topBannerAction";
import { changeActiveItemAction } from "../../actions/navAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import captionApi from "../../api/captionApi";
import specialApi from "../../api/specialApi";

/****************************************
    Component for special detail page
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/
class SpecialDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      business: Businesses.indexOf("special"),
      mainTitle: "",
      title: "",
      description: "",
      date: "0000-00-00",
      arrImage: [],
      arrIds: [],
      prev: 0,
      next: 0,
    };

    this.load = this.load.bind(this);
    this.getIds = this.getIds.bind(this);
  }

  componentWillMount() {
    store.dispatch(changeActiveItemAction(Businesses.indexOf("special")));
    store.dispatch(
      changeTopBannerAction({
        page: "special_detail",
        showSearch: false,
        isHome: false,
      })
    );
  }

  componentDidMount() {
    $("#footer").css("visibility", "hidden");
    this.getIds();
    this.load(this.state.id);
    window.articleGallery();
    window.onSetClass("light");
    window.playVideo();
  }

  componentWillUnmount() {}

  componentDidUpdate() {
    window.scrollTop(".revolution-detail");
    window.playVideo();
  }

  componentWillReceiveProps(newProps) {
    this.load(newProps.match.params.id);
  }

  load(id) {
    var caption = "";

    captionApi.getCaptions("special").then((json) => {
      if (json.status === 200) {
        caption =
          json.data[
            CaptionCodes[PagesForCaption.indexOf("special")].indexOf(
              "special_list"
            )
          ];
      } else {
        store.dispatch(addNotification(`${lang("server_err")}`, "error"));
      }
    });

    specialApi.getFind(id).then((json) => {
      if (json.status === 200 && json.data) {
        var date = new Date(Date.parse(json.data.date));
        var d = date.getDate();
        var m = date.getMonth() + 1;
        var prevIdValue =
          this.state.arrIds.indexOf(id) === 0
            ? this.state.arrIds[this.state.arrIds.length - 1]
            : this.state.arrIds[this.state.arrIds.indexOf(id) - 1];
        var nextIdValue =
          this.state.arrIds.indexOf(id) + 1 >= this.state.arrIds.length
            ? this.state.arrIds[0]
            : this.state.arrIds[this.state.arrIds.indexOf(id) + 1];

        date = date.getFullYear() + "." + m + "." + d + ".";
        this.setState({
          id: id,
          mainTitle:
            caption === undefined ||
            caption.title === undefined ||
            caption.title === null
              ? ""
              : caption.title,
          title: json.data.title === null ? "" : json.data.title,
          description:
            json.data.description === null ? "" : json.data.description,
          arrImage: json.data.media,
          date: date,
          prev: prevIdValue,
          next: nextIdValue,
        });
        $("#footer").css("visibility", "visible");
      } else {
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
        }
      }
    });
  }

  getIds() {
    specialApi.getAll().then((json) => {
      if (json.status === 200 && json.data) {
        var arr = [];

        json.data.data.forEach(function(item) {
          arr.push(item.id);
        });

        this.setState({
          arrIds: arr,
        });
      } else {
        if (json.status === 620) {
          store.dispatch(addNotification(`${lang("access_deny")}`, "error"));
        } else {
        }
      }
    });
  }

  render() {
    return (
      <section className="ftco-section pt-0 revolution-detail">
        <div className="container pt-5">
          <div className="row">
            <div className="col-md-10">
              <div className="portfolio-title">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="mb-none">
                      {/* <span dangerouslySetInnerHTML={{__html: this.state.mainTitle}}></span> */}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <ul className="top-pager">
                <li className="center">
                  <Link
                    to={`/special/${this.state.prev}`}
                    title={lang("pager_prev")}
                  >
                    <i className="icon icon-chevron-left"></i>
                  </Link>
                </li>
                <li className="center ml-2 mr-2">
                  <Link to="/special" title={lang("pager_back")}>
                    <i className="icon icon-th teal"></i>
                  </Link>
                </li>
                <li className="center">
                  <Link
                    to={`/special/${this.state.next}`}
                    title={lang("pager_next")}
                  >
                    <i className="icon icon-chevron-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="solid tall" />
        <div className="container">
          <div className="row">
            <Content
              business={this.state.business}
              id={this.state.id}
              title={this.state.title}
              description={this.state.description}
              images={this.state.arrImage}
              date={this.state.date}
              prev={this.state.prev}
              next={this.state.next}
            />
          </div>
        </div>
      </section>
    );
  }
}

class Content extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.checkMedia = this.checkMedia.bind(this);
    this.getMedia = this.getMedia.bind(this);
  }

  checkMedia(item) {
    return item.format === 1;
  }

  getMedia() {
    let media = [];
    media = this.props.images.filter(this.checkMedia);

    if (media.length !== 0) {
      return media[0].name;
    } else return false;
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="ftco-animate fadeIn ftco-animated title">
          <h4>
            <span dangerouslySetInnerHTML={{ __html: this.props.title }}></span>
            &nbsp;
            <div data-lightbox="gallery">
              {this.props.images.map((image, key) =>
                image.format === 0 ? (
                  <Link
                    key={key}
                    to={apiConstant.tablet(
                      this.props.business,
                      this.props.id,
                      image.name
                    )}
                    data-lightbox="gallery-item"
                    className="hidden"
                  >
                    &nbsp;&nbsp;[<i className="icon icon-camera"></i>]
                  </Link>
                ) : (
                  ""
                )
              )}
            </div>
            {this.getMedia() !== false && (
              <a
                href={apiConstant.desktop(
                  this.props.business,
                  this.props.id,
                  this.getMedia()
                )}
                className="play-video"
              >
                [<i className="icon icon-video-camera"></i>]
              </a>
            )}
          </h4>
        </div>
        <div
          className="ftco-animate fadeInUp ftco-animated description"
          dangerouslySetInnerHTML={{ __html: this.props.description }}
        ></div>
        <p className="center">({this.props.date})</p>
        <hr className="solid tall" />
        <div className="bottom-area">
          <ul className="bottom-pager">
            <li className="center mr-4">
              <a
                href={`/special/${this.props.prev}`}
                title={lang("pager_prev")}
              >
                <i className="icon icon-arrow-left"></i>
              </a>
            </li>
            <li className="center ml-4">
              <a
                href={`/special/${this.props.next}`}
                title={lang("pager_next")}
              >
                <i className="icon icon-arrow-right"></i>
              </a>
            </li>
            <li className="float-right">
              <a href="/special" title={lang("pager_back")}>
                <i className="icon icon-share"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(SpecialDetail);
